/* eslint-disable import/no-anonymous-default-export */
export default (branchStats = [], action) => {
  switch (action.type) {
    case "GET_ALL_BRANCH_STATS":
      return action.payload;

    default:
      return branchStats;
  }
};
